angular.module("digitalLeasing.module").component("verificationManageBank", {
    templateUrl: "ng/components/digitalLeasing/deliberaBanca/verificationManageBank/verificationManageBank.view.html",
    bindings: {
      model: "=",
      domande: "="
    },
    controllerAs: "verificationManageBankCtrl",
    controller: function VerificationManageBank() {
      var self = this;
  
      self.$onInit = function () {
        console.log("model verificationManageBank", self.model);
      };

      self.check = function (el) {
        
      }
    }, 
  });